import React, {useState, useEffect} from 'react';
import ComponentRegistry from '../registry.js';
import globals from '../../globals.json';

export default function Linear(props) {
  console.log('Linear',props);
  const [cleanup, setCleanup] = useState(false);
  const [globalData, setGlobalData] = useState({});

  const contentData = props.data;
  const stepIndex = props.controller.getStepIndex();
  const moduleIndex = props.controller.getModuleIndex();

  useEffect(() => {
    setGlobalData(globals);
  }, [])

  const onCleanup = () => {
    setCleanup(true)
    setTimeout(
      () => {
        props.controller.stepComplete()
        setCleanup(false)
      },
      400
    )
  }

  const getComponent = () => {
    if (!contentData.steps) {
      return "invalid JSON format, missing steps property"
    } else if (!contentData.steps[stepIndex]) {
      return "invalid step index"
    }
    const stepTotal = contentData.steps.length;
    const data = contentData.steps[stepIndex];
    return ComponentRegistry(data.type, {
      "key": `mod${moduleIndex}-step${stepIndex}-reset${props.resetIndex}`,
      "data": data,
      "globalData": globalData,
      "setGlobalData": setGlobalData,
      "stepIndex": stepIndex,
      "stepTotal": stepTotal,
      "cleanup": cleanup,
      "onCleanup": onCleanup,
      //the linear functionality is built into the controller. All we need to do is point each component to the stepComplete event handler
      "onComplete": props.controller.stepComplete,
      "reset": props.controller.resetStep,
      audioController: props.audioController,
      audioCollection: props.audioCollection,
      scoring: props.scoring,
      setScoring: props.setScoring,
      sharedData: props.sharedData,
      setSharedData: props.setSharedData,
      setModuleIndex: props.controller.setModuleIndex,
      handleSubmitSurvey: props.handleSubmitSurvey
    })
  }

  return (
    <div className={`Linear ${cleanup ? 'cleanup' : 'not-cleanup'}`}>
      {getComponent(props.force)}
    </div>
  )
}
